import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicProfilesRoutingModule } from './public-profiles-routing.module';
import { DoctorComponent } from './pages/doctor/doctor.component';
import { HospitalComponent } from './pages/hospital/hospital.component';
import { LaboratoryComponent } from './pages/laboratory/laboratory.component';
import { DoctorHeaderComponent } from './components/doctor-header/doctor-header.component';
import { PublicProfileManagerComponent } from './components/public-profile-manager/public-profile-manager.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ImageCenterComponent } from './pages/image-center/image-center.component';
import { PharmacyComponent } from './pages/pharmacy/pharmacy.component';
import { InsuranceComponent } from './pages/insurance/insurance.component';
import { SuraComponent } from './pages/sura/sura.component';
import { PhysiotherapyComponent } from './pages/physiotherapy/physiotherapy.component';
import { HealthBeautyComponent } from './pages/health-beauty/health-beauty.component';
import { DentalServicesComponent } from './pages/dental-services/dental-services.component';
import { OpticsComponent } from './pages/optics/optics.component';
import { PrimaryCareClinicsComponent } from './pages/primary-care-clinics/primary-care-clinics.component';
import { AnotherProvidersComponent } from './pages/another-providers/another-providers.component';
import { LaboratoryDiscountsComponent } from './pages/laboratory-discounts/laboratory-discounts.component';
import { ImageCenterDiscountsComponent } from './pages/image-center-discounts/image-center-discounts.component';
import { L10nTranslationModule } from 'angular-l10n';
import { AppointmentLocationComponent } from './components/appointment-location/appointment-location.component';
import { AppointmentLocationsComponent } from './components/appointment-locations/appointment-locations.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { TreatmentsComponent } from './components/treatments/treatments.component';
import { MedicalConditionsComponent } from './components/medical-conditions/medical-conditions.component';
import { GeneralInformationComponent } from './components/general-information/general-information.component';
import { EducationComponent } from './components/education/education.component';
import { CareerPathComponent } from './components/career-path/career-path.component';
import { PublicationsComponent } from './components/publications/publications.component';
import { FooterComponent } from './components/footer/footer.component';
import { ReschedulePublicProfileComponent } from './components/reschedule-public-profile/reschedule-public-profile.component';
import { ProfessionalLicenseComponent } from './pages/professional-license/professional-license.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { CareerPathLicenseComponent } from './components/career-path/career-path-licenses/career-path-licenses.component';

@NgModule({
  declarations: [
    DoctorComponent,
    HospitalComponent,
    LaboratoryComponent,
    DoctorHeaderComponent,
    PublicProfileManagerComponent,
    ImageCenterComponent,
    PharmacyComponent,
    InsuranceComponent,
    SuraComponent,
    PhysiotherapyComponent,
    HealthBeautyComponent,
    DentalServicesComponent,
    OpticsComponent,
    PrimaryCareClinicsComponent,
    AnotherProvidersComponent,
    LaboratoryDiscountsComponent,
    ImageCenterDiscountsComponent,
    AppointmentLocationComponent,
    AppointmentLocationsComponent,
    GalleryComponent,
    TreatmentsComponent,
    MedicalConditionsComponent,
    GeneralInformationComponent,
    EducationComponent,
    CareerPathComponent,
    PublicationsComponent,
    FooterComponent,
    ReschedulePublicProfileComponent,
    ProfessionalLicenseComponent,
    CareerPathLicenseComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    PublicProfilesRoutingModule,
    L10nTranslationModule,
    GoogleMapsModule
  ],
  exports:[
    DoctorHeaderComponent,
    AppointmentLocationsComponent,
    GalleryComponent,
    TreatmentsComponent,
    MedicalConditionsComponent,
    GeneralInformationComponent,
    EducationComponent,
    CareerPathComponent,
    PublicationsComponent,
    FooterComponent
  ],
  bootstrap: [
    DoctorHeaderComponent,
    AppointmentLocationsComponent,
    GalleryComponent,
    TreatmentsComponent,
    MedicalConditionsComponent,
    GeneralInformationComponent,
    EducationComponent,
    CareerPathComponent,
    PublicationsComponent,
    FooterComponent
  ]
})
export class PublicProfilesModule { }
